/* eslint-disable no-unused-vars */
import React from 'react'
import { Select } from 'antd'
import { useTranslation } from 'next-i18next'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import styles from './OffsetFieldForm.module.scss'
import { CustomCol, CustomTitle, CustomText } from 'src/components'
import {
  changeUserCurrency,
  currencyListSelector,
  getOffsetByExcelVerifyErrors,
  offsetByExcelSelector,
  setCurrency
} from 'src/features'
import { currencyCodes } from 'src/features/currencies/constants'

interface OffsetFieldFormProps {
    title: string
    placeholder: string
    value: string
    handleChange: (value: string) => void
    errorKey: string
    showKeys?: boolean
}

const OffsetFieldForm: React.FC<OffsetFieldFormProps> = (props) => {
  const {
    title,
    placeholder,
    value,
    handleChange,
    errorKey,
    showKeys = true
  } = props
  const { t } = useTranslation()
  const { keys: excelKeys } = useAppSelector(offsetByExcelSelector)
  const { errors } = useAppSelector(getOffsetByExcelVerifyErrors)
  const dispatch = useAppDispatch()
  const currencies = useAppSelector(currencyListSelector)

  const getErrorByKey = (key: string) => errors.filter((x) => x.key === key)
  const handleCurrencyChange = (code: string) => {
    if (!currencyCodes.includes(code)) return
    const currency = currencies?.find((c) => c.value === code)
    dispatch(setCurrency(code))
    dispatch(changeUserCurrency({ currency: currency.id }))
  }
  return (
    <CustomCol
      lg={8}
      className={styles.colPadding}
    >
      <CustomTitle
        label={title}
        className={styles.titlePosition}
      />
      <Select
        showSearch
        size='large'
        className='select-input'
        value={value}
        placeholder={placeholder}
        onChange={(value: string) => {
          handleChange(value)
          handleCurrencyChange(value)
        }}
      >
        {showKeys ? (
          <>
            {excelKeys.map((item, idx) => (
              <Select.Option
                key={idx}
                value={item}
              >
                {item}
              </Select.Option>
            ))}
          </>
        ) : (
          <>
            <Select.Option value={'TONS'}>
              {t('developers.OffSet.Tons')}
            </Select.Option>
            <Select.Option value={'KG'}>
              {t('developers.OffSet.KG')}
            </Select.Option>
            {currencyCodes.map((code) => (
              <Select.Option
                key={'option-unit-' + code}
                value={code}
              >
                {code}
              </Select.Option>
            ))}
          </>
        )}
      </Select>

      {/* Errors */}
      {getErrorByKey(errorKey).map((item, idx) => (
        <CustomText
          label={t(`developers.OffSet.errors.${item.label}`)}
          key={idx}
          type='secondary'
        />
      ))}
    </CustomCol>
  )
}

export default OffsetFieldForm
